const zhCategory = {
  title: '分类浏览',
  subtitle: '按你的喜好探索韩漫世界',
  stats: {
    totalWorks: '作品总数',
    totalReads: '累计阅读',
  },
  filters: {
    all: '全部',
    romance: '恋爱',
    fantasy: '奇幻',
    action: '动作',
    thriller: '悬疑',
    comedy: '搞笑',
    drama: '剧情',
    daily: '日常',
  },
  noResults: '该分类下暂无作品',
};

export default zhCategory;